const textFileTypes = ['.docx', '.txt'];

const audioFileTypes = ['audio/*'];

const INTERVIEW = {
  files: {
    maxFileSize: 1 * 1024 * 1024 * 1024, // 1 GB
    audio: {
      name: 'audio',
      types: audioFileTypes,
      maxPerInterview: 10,
    },
    transcript: {
      name: 'transcript',
      types: textFileTypes,
      maxPerInterview: 10,
    },
  },
};

export default INTERVIEW;
